<app-preloader></app-preloader>
<app-navbar></app-navbar>
<router-outlet (activate)="onActivate($event)"></router-outlet>
<app-footer></app-footer>